module.exports = __webpack_public_path__ + "img/proposta-logo.4ba804eb.png";